
// import axios from "axios";

// const API = axios.create({
//   baseURL: "https://final-project-3-qemw.onrender.com/api",
// });

// // export default API;
// import axios from "axios";

// const API = axios.create({
//   baseURL: "https://final-project-3-qemw.onrender.com/api",
//   timeout: 60000,
// });

// export default API;
import axios from "axios";

const API = axios.create({
  baseURL: "https://final-project-3-qemw.onrender.com/api",
  timeout: 60000,
});

export default API;